import React from "react";
import Loading from "../../components/elements/loading";

const LoadingPage: React.SFC = () => {
    return (
        <Loading loading={true}></Loading>
    )
}
export default LoadingPage;